import { render, staticRenderFns } from "./RequestsHistory.vue?vue&type=template&id=7fcc73d4&scoped=true"
import script from "./RequestsHistory.vue?vue&type=script&lang=js"
export * from "./RequestsHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestsHistory.vue?vue&type=style&index=0&id=7fcc73d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc73d4",
  null
  
)

export default component.exports